import { LinkItem } from '~/models/head/types'

export const preconnectLink = (
  origin: string,
  crossorigin: boolean = true,
  rel: string = 'preconnect'
): LinkItem => ({
  rel,
  href: origin,
  ...(crossorigin ? { crossorigin: '' } : {})
})
